import { defineComponent as _defineComponent } from 'vue'
import { useTranslate } from '../../../i18n/useTranslation'
import { ConfigCategory } from '../type/ConfigCategory'

export interface ClvrConfigCategoryProps {
    category: ConfigCategory
    context: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ClvrConfigCategory',
  props: {
    category: null,
    context: null
  },
  setup(__props: any) {

const props = __props as { category: ConfigCategory, context: string }



const $t = useTranslate()

return { __sfc: true,props, $t }
}

})